export default {
    listWebserviceType: () => {
        const webserviceType = [
            { id: '-', name: '-' },
            { id: 'soap', name: _('SOAP') }
        ];

        return {
            data: webserviceType,
            count: webserviceType.length
        };
    },
    listWebserviceAuthentication: () => {
        const webserviceAuthentication = [
            { id: 'required', name: _('Auth Required') },
            { id: 'none', name: _('No login needed') }
        ];

        return {
            data: webserviceAuthentication,
            count: webserviceAuthentication.length
        };
    }
};
